<template>
  <footer class="page-container">
    <h3><label for="member_email">Subscribe</label></h3>
    <form
            id="revue-form"
            class="newsletter-form"
            name="revue-form"
            target="_blank"
            action="https://www.getrevue.co/profile/atrvasa/add_subscriber"
            method="post"
    >
      <input
              id="member_email"
              class="newsletter-input"
              type="email"
              name="member[email]"
              required=""
              placeholder="Email address"
      >
      <input
              id="member_submit"
              class="button newsletter-button"
              type="submit"
              value="Subscribe"
              name="member[subscribe]"
      >
    </form>
    <p>
      You can read the previous issues and listen to our podcast at <a
            href="https://blog.atrvasa.com"
            target="_blank"
    >blog.atrvasa.com</a>.
    </p>
  </footer>
</template>

<script>

  export default {
    name: "Footer",

    data() {
      return {}
    },

    mounted() {
    },

    methods: {}
  }
</script>

<style scoped>

  footer {
    border-top: 1px solid #323232;
  }

  footer p,
  footer h3 label {
    color: #979797;
  }

  footer p a {
  }

  .newsletter-form {
    position: relative;
    max-width: 400px;
    /*margin: 0 auto;*/
    box-sizing: border-box;
  }

  .newsletter-input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 80px 10px 20px;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #323232;
    font-size: 16px;
    background-color: #1a1a1a;
    color: #e1e1e1;
  }

  .newsletter-input:focus {
    outline: none;
    border-color: #41b883;
    background-color: black;
  }

  .newsletter-button.button {
    position: absolute;
    padding: 4px 20px;
    margin: 0;
    height: calc(100% - 8px);
    right: 4px;
    top: 4px;
    border-color: #41b883;
    color: #34495e;
    cursor: pointer;
  }

  .newsletter-button.button:focus {
    outline: none;
    background-color: #40af7b;
    color: #e1e1e1;
  }
</style>
